import View from 'mixins/view';
import MatchBarComponent from './match-bar-component';

const templates = {
    regular: '#mustache-gamebar-item-regular',
    empty: '#mustache-gamebar-item-empty',
    current: '#mustache-gamebar-item-current',
    popover: '#mustache-gamebar-popover',
    rwd: '#mustache-gamebar-section-rwd',
    sponsors: '#mustache-gamebar-section-sponsors',
};

const elements = {
    container: '.gamebar-section',
    list: '.gamebar-list',
    desktop: '.gamebar-section-desktop',
    rwd: '.gamebar-section-rwd',
    sponsors: '.gamebar-section-sponsors',
};

const mustache = new MatchBarComponent();

export default class extends View
{
    constructor(model) {
        super(model);
        this.setRootEl($(elements.container));
    }

    rendering(t, data) {
        const template = $(templates[t]);
        mustache.change(template);
        mustache.prepare(t, data);
        return mustache.render();
    }

    rwd(data) {
        this.status(data);
        return this.rendering('rwd', data);
    }

    sponsors(data) {
        return this.rendering('sponsors', data);
    }

    regular(data) {
        return this.rendering('regular', data);
    }

    empty(data) {
        return this.rendering('empty', data);
    }

    popover(data) {
        return this.rendering('popover', data);
    }

    current(data) {
        this.status(data);
        return this.rendering('current', data);
    }

    status(o) {
        $('.dynamic-match-main-status').removeClass('gamebar-current-past gamebar-current-live gamebar-current-upcoming').addClass('gamebar-current-' + o.status);
    }

    render(collection) {
        collection.past.forEach(o => {
            $(elements.list).append((o === false) ? this.empty(o) : this.regular(o));
        });

        $(elements.list).append(this.current(collection.live));
        $(elements.rwd).append(this.rwd(collection.live));
        $(elements.sponsors).append(this.sponsors(collection.live));

        collection.upcoming.forEach(o => {
            $(elements.list).append((o === false) ? this.empty(o) : this.regular(o));
        });
        this.status(collection.live);
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/match-bar/match-bar-view.js